import fonts from './fonts';
import responsive from './responsive';

export const blue = '#0064b4';
export const lightBlue = '#78dcff';
export const gray = '#969696';
export const black = '#000000';
export const backgroundColor = '#ebebeb';

export const bodyFontSize = {
    'Mobile': 15,
    'Tablet': 15,
    'Laptop': 15,
    'Desktop': 15
}

export default {
    'Body': {
        ...fonts.Regular,
        color: blue,
        lineHeight: '1.2',
        [responsive.Mobile]: {
            fontSize: bodyFontSize.Mobile,
        },
        [responsive.Tablet]: {
            fontSize: bodyFontSize.Tablet,
        },
        [responsive.Laptop]: {
            fontSize: bodyFontSize.Laptop,
        },
        [responsive.Desktop]: {
            fontSize: bodyFontSize.Desktop,
        },

        '& *::selection': {
            color: 'white',
            backgroundColor: blue
        }
    },
    'Regular': {
        ...fonts.Regular,
    },
    'Bold': {
        ...fonts.Bold,
    },
    'Condensed': {
        ...fonts.Condensed,
    },
    'Menu': {
        ...fonts.Condensed,
        color: blue,
        lineHeight: '1.2',
        fontSize: '.933rem',
        // textTransform: 'uppercase',
        letterSpacing: '1px',

        '&:hover': {
            color: 'white',
            backgroundColor: blue
        }
    },
    'TitleH1': {
        ...fonts.Condensed,
        color: blue,
        lineHeight: '1',
        fontSize: '2.666rem',
        letterSpacing: '1px',
    },
    'TitleH2': {
        ...fonts.Condensed,
        color: blue,
        lineHeight: '1',
        fontSize: '2rem',
        letterSpacing: '1px',
    },
    'TitleH3': {
        ...fonts.Condensed,
        color: blue,
        lineHeight: '1',
        fontSize: '1.333rem',
        letterSpacing: '1px',
    },
    'Credits': {
        ...fonts.Regular,
        color: blue,
        lineHeight: '1.1',
        fontSize: '.8rem',
        letterSpacing: '1px',
    },
    'Intro': {
        ...fonts.Regular,
        color: blue,
        fontSize: '1.4666rem',
        lineHeight: '1.1',
        letterSpacing: '1px',
    },
    'ObjectFitCover': {
        fontFamily: '"object-fit: cover;"'
    },
    'ObjectFitContain': {
        fontFamily: '"object-fit: contain;"'
    },
    'Tag': {
        border: `1px solid ${blue}`,
        borderRadius: 2,
        fontSize: 13,
        backgroundColor: 'white',
        padding: '2px 4px 0',
        cursor: 'pointer',

        '&:hover': {
            color: 'white',
            backgroundColor: blue,
        }
    },
    'HR':{
        display: 'block',
        height: 6,
        marginBottom: 6,
        border: 'none',
        backgroundColor: blue
    }
};


// WEBPACK FOOTER //
// ./src/constants/stylesheet.ts